module.exports = __webpack_public_path__ + "img/Quiz.ad9183d5.jpg";